module.exports = __webpack_public_path__ + "static/img/icon1.68542b6d.png";